import React, { useContext, useEffect, useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'react-bootstrap';
import ModalHeader from 'react-bootstrap/ModalHeader';
import { IconWrapper } from '../../../common/IconWrapper';
import { faCheckCircle, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import UserContext from '../../../user/UserContext';
import axios from 'axios';
import AuthContext from '../../../authentication/AuthContext';
import { useAlert } from 'react-alert';

export default function MinimumOrderQuantities() {
    const [moqDetail, setMoqDetail] = useState();
    const [showModal, setShowModal] = useState(false);
    const { userDetails } = useContext(UserContext);
    const cas = useContext(AuthContext);
    const alert = useAlert();

    useEffect(() => {
        if (userDetails.currentFranchise) {
            const url =
                window.CONFIG['ws.activoc-web-order-api.moq.progress'] +
                '?franchiseCode=' +
                userDetails.currentFranchise.code;
            axios
                .get(url, {
                    headers: {
                        Authorization: cas,
                        'Content-Type': 'application/json'
                    }
                })
                .then(response => {
                    setMoqDetail(response.data);
                })
                .catch(() => {
                    alert.error('Unable to retrieve MOQ progress');
                });
        }
        // eslint-disable-next-line
    }, [cas, userDetails]);

    return moqDetail ? (
        <>
            <div className={'moq-wrapper-my-orders flex'}>
                <div>
                    <div>Minimum Order Quantities:</div>
                    <div className={'moqs'}>
                        {moqDetail.ambient && (
                            <p
                                className={
                                    moqDetail.ambient.submittedCases >= moqDetail.ambient.minimumOrderQtyNoSurcharge
                                        ? 'success'
                                        : 'error'
                                }
                            >
                                Ambient: {moqDetail.ambient.submittedCases}/
                                {moqDetail.ambient.minimumOrderQtyNoSurcharge}
                            </p>
                        )}
                        {moqDetail.chillfreeze && (
                            <p
                                className={
                                    moqDetail.chillfreeze.submittedCases >=
                                        moqDetail.chillfreeze.minimumOrderQtyNoSurcharge &&
                                    moqDetail.chillfreeze.errorMessages.length === 0
                                        ? 'success'
                                        : 'error'
                                }
                            >
                                Chill/Freeze: {moqDetail.chillfreeze.submittedCases}/
                                {moqDetail.chillfreeze.minimumOrderQtyNoSurcharge}
                            </p>
                        )}
                    </div>
                </div>
                <Button variant={'secondary'} onClick={() => setShowModal(true)}>
                    See More
                </Button>
            </div>
            <Modal
                onHide={() => setShowModal(false)}
                show={showModal}
                dialogClassName={'moq-modal'}
                size={'lg'}
            >
                <ModalHeader closeButton>
                    <h2>Minimum Order Quantity Detail:</h2>
                </ModalHeader>
                <ModalBody>
                    <div className={'moq-modal-content'}>
                        {moqDetail.ambient && (
                            <div>
                                <h3>
                                    <span>Ambient: </span>
                                    <span
                                        className={
                                            moqDetail.ambient.submittedCases >=
                                            moqDetail.ambient.minimumOrderQtyNoSurcharge
                                                ? 'success'
                                                : 'error'
                                        }
                                    >
                                        {moqDetail.ambient.submittedCases}/{moqDetail.ambient.minimumOrderQtyNoSurcharge}
                                    </span>
                                    <span> cases</span>
                                </h3>
                                <ul className={'fa-ul'}>
                                    {moqDetail.ambient.errorMessages.map((message, index) => (
                                        <li key={index}>
                                            <span className="fa-li error">
                                                <IconWrapper icon={faExclamationCircle} />
                                            </span>
                                            {message}
                                        </li>
                                    ))}
                                    {moqDetail.ambient.infoMessages.map((message, index) => (
                                        <li key={index}>
                                            <span className="fa-li success">
                                                <IconWrapper icon={faCheckCircle} />
                                            </span>
                                            {message}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                        {moqDetail.chillfreeze && (
                            <div>
                                <h3>
                                    <span>Chill/Freeze: </span>
                                    <span
                                        className={
                                            moqDetail.chillfreeze.submittedCases >=
                                                moqDetail.chillfreeze.minimumOrderQtyNoSurcharge &&
                                            moqDetail.chillfreeze.errorMessages.length === 0
                                                ? 'success'
                                                : 'error'
                                        }
                                    >
                                        {moqDetail.chillfreeze.submittedCases}/
                                        {moqDetail.chillfreeze.minimumOrderQtyNoSurcharge}
                                    </span>
                                    <span> cases</span>
                                </h3>
                                <ul className={'fa-ul'}>
                                    {moqDetail.chillfreeze.errorMessages.map((message, index) => (
                                        <li key={index}>
                                            <span className="fa-li error">
                                                <IconWrapper icon={faExclamationCircle} />
                                            </span>
                                            {message}
                                        </li>
                                    ))}
                                    {moqDetail.chillfreeze.infoMessages.map((message, index) => (
                                        <li key={index}>
                                            <span className="fa-li success">
                                                <IconWrapper icon={faCheckCircle} />
                                            </span>
                                            {message}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button variant={'primary'} onClick={() => setShowModal(false)}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    ) : (
        <></>
    );
}
